import { useState } from 'react';
import { Collapsible } from '@monash/portal-react';
import classNames from 'classnames';
import ItemDetails from '../item-details/ItemDetails';
import c from './expandable-card.module.scss';

const ExpandableCard = ({
  title,
  expandedContent,
  status,
  label,
  onClick,
  publishDate,
  hasCheckbox,
  checked,
  handleCheck,
  selected,
  labelLineBreak = true,
}) => {
  const [expanded, setExpanded] = useState(false);
  const Element = onClick ? 'button' : 'div';

  return (
    <div className={classNames(c.expandableCard, { [c.selected]: selected })}>
      <div className={c.header}>
        <Element
          className={c.headingGroupButton}
          onClick={onClick}
          type="button"
        >
          <ItemDetails
            title={title}
            label={label}
            status={status}
            publishDate={publishDate}
            labelLineBreak={labelLineBreak}
            setExpanded={setExpanded}
            expanded={expanded}
            handleCheck={handleCheck}
            checked={checked}
          />
        </Element>
      </div>

      <Collapsible expanded={expanded}>
        <div
          className={classNames(c.description, {
            [c.hasCheckbox]: hasCheckbox,
          })}
        >
          {expandedContent}
        </div>
      </Collapsible>
    </div>
  );
};

export default ExpandableCard;
